import sendBeacon from './sendBeacon';
import getEnvelope from './envelope';
import constructData from './constructData';
import WeapiEventPayload from './contracts/weapiEventPayload';

const startTracking = (
  env,
  url,
  track,
  project,
  correlationId,
  payloadMetaAttributes,
  debug,
) => {
  const trackData = async data => {
    const { eventName, customAttributes = {}, overrides = {} } = data || {};
    const envelope = await getEnvelope(
      env,
      project,
      track,
      eventName,
      correlationId,
      overrides,
    );
    const fullData: WeapiEventPayload = constructData(
      envelope,
      customAttributes,
      payloadMetaAttributes,
    );
    const isProdLikeEnv =
      env === 'production' || env === 'prod' || env === 'uat';

    if (debug && !isProdLikeEnv) {
      console.debug(
        `Eventable clickstream payload for ${eventName}: `,
        fullData,
      );
    }
    // Add eventName as a query param so it's easier to find in Chrome dev tools.
    sendBeacon(`${url}?${eventName}`, fullData);
  };

  return trackData;
};

export default startTracking;
